import { render, staticRenderFns } from "./dj-all.vue?vue&type=template&id=78c8b63a&scoped=true"
import script from "./dj-all.vue?vue&type=script&lang=js"
export * from "./dj-all.vue?vue&type=script&lang=js"
import style0 from "./dj-all.vue?vue&type=style&index=0&id=78c8b63a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c8b63a",
  null
  
)

export default component.exports